// Fixed, filterable vocabularies for the Template Factory wizard.
// Designed to be extended without redesigning the form — append new items freely.

export const INDUSTRIES = [
  "Business", "Consulting", "Coach", "Church", "Nonprofit", "Construction", "Medical",
  "Dental", "Legal", "Financial", "Real Estate", "Restaurant", "Retail", "Education",
  "Government", "Manufacturing", "Automotive", "Beauty & Salon", "Fitness", "Technology",
  "Portfolio / Personal Brand", "Author", "Photography", "Event Services",
  "Veteran-Owned Business", "Minority-Owned Business", "Other",
];

export const BUSINESS_STAGES = ["Startup", "Launch", "Growth", "Established", "Enterprise"];

export const SBA_TAGS = [
  "Plan Your Business", "Launch Your Business", "Manage Your Business", "Grow Your Business",
];

export const TARGET_CUSTOMERS = [
  "Startup", "Small Business", "Enterprise", "Church", "Nonprofit", "Government", "Other",
];

export const DIFFICULTIES = ["Beginner", "Intermediate", "Advanced"];

export const STATUSES = ["Draft", "In Review", "QA Testing", "Ready for Release", "Published", "Archived", "Retired"];

export const VISIBILITIES = ["Private", "Internal", "Early Access", "Public", "Hidden"];

// Multiple marketplace badges may apply to a template.
export const BADGES = [
  "Premium", "Best Seller", "New Release", "Staff Pick", "AI Ready",
  "Featured", "Trending", "Limited", "Editor's Choice", "Value",
];

// Curated product series (Contractor, Business, Organization, Ecommerce lines).
export const SERIES = [
  "Contractor Series", "Outdoor Services Series", "Business Series",
  "Organization Series", "Ecommerce Series", "Professional Services Series",
  "Creative & Portfolio Series",
];

// Page vocab for the dynamic Pages builder.
export const PAGE_ICONS = ["home", "info", "grid", "image", "star", "mail", "file", "calendar", "shopping-bag", "users", "book", "phone"];
export const PAGE_STATUSES = ["Published", "Draft", "Coming Soon", "Hidden"];

// Business Capabilities grouped into logical business solutions.
export const BUSINESS_CAPABILITY_GROUPS = {
  Sales: ["Online Store (E-Commerce)", "Shopping Cart", "Payments", "Invoicing", "Quotes & Estimates", "Booking & Scheduling"],
  Marketing: ["Email Marketing", "Newsletter", "SMS Notifications", "SEO Tools", "Landing Pages", "Promotions & Coupons", "Social Integration"],
  "Customer Management": ["CRM", "Client Portal", "Customer Dashboard", "Appointment Booking", "Calendar", "Live Chat", "Support Tickets", "Membership"],
  Content: ["Blog", "Portfolio Gallery", "Testimonials", "FAQ", "Knowledge Base", "File Uploads", "Document Management", "Media Library"],
  AI: ["AI Assistant", "AI Recommendations", "AI Content Generation", "AI Lead Qualification", "AI Chatbot", "AI Search"],
};

export const AIPOS_COMPATIBILITY = [
  "AIPOS Ready", "AI Strategists", "Mission Manager Compatible", "Workflow Builder Compatible",
  "Automation Center Compatible", "Memory Center Compatible", "Training Center Compatible",
  "Evaluation Center Compatible", "Knowledge Base Compatible", "AI Resource Manager Compatible",
  "AI Transparency Compatible", "Audit Trail Enabled", "Activity Timeline Enabled",
  "Client Portal Compatible", "Export Center Compatible",
];

export const BUSINESS_CAPABILITIES = [
  "Contact Forms", "Appointment Booking", "Calendar", "CRM", "Client Portal", "Customer Dashboard",
  "Online Store (E-Commerce)", "Shopping Cart", "Payments", "Invoicing", "Membership",
  "Learning Management (LMS)", "Course Platform", "Blog", "Newsletter", "Email Marketing",
  "SMS Notifications", "Analytics Dashboard", "Testimonials", "Portfolio Gallery", "File Uploads",
  "Document Management", "Team Management", "Knowledge Base", "FAQ", "Live Chat", "AI Assistant",
  "Multi-language Support", "Search Functionality", "User Authentication", "Admin Dashboard",
];
